require("savage-image");
var Camera = require("savage-camera");
var Savage = require("savage-query");
var $ = require("./lib/qsa");
var debounce = require("./lib/debounce");

var blocks = $(".scroll-block");

var svg = $.one("savage-image");
var scrollers = $.one(".scrollers");

var ready = function() {

  var actual = svg.querySelector("svg");

  var cam = new Camera(actual);

  var current = null;

  var onScroll = debounce(function() {
    var sBounds = scrollers.getBoundingClientRect();
    if (sBounds.top < 0 && sBounds.bottom > window.innerHeight) {
      document.body.classList.add("scrolling");
    } else {
      document.body.classList.remove("scrolling");
    }
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      var bounds = block.getBoundingClientRect();
      if (bounds.top > 0 && bounds.top < window.innerHeight) {
        var layer = block.getAttribute("data-layer");
        if (!layer) continue;
        if (current == layer) return;
        current = layer;
        Savage(actual).addClass("zoomed");
        var element = svg.querySelector("#" + layer);
        var previous = svg.querySelector(".active");
        if (previous) {
          previous.setAttribute("class", previous.getAttribute("class").replace(/\s*active\s*/g, ""));
        }
        element.setAttribute("class", element.className + " active");
        cam.zoomTo(element, 100);
        return;
      }
    }
    if (current != "Liquid") {
      // cam.zoomTo("#Liquid");
      // current = "Liquid";
      // Savage(actual).removeClass("zoomed");
    }
  }, 200);

  window.addEventListener("scroll", onScroll);

};

if (svg) {
  if (svg.readyState == 4) {
    ready();
  } else {
    svg.addEventListener("load", ready);
  }
}